import { forwardRef, useImperativeHandle, useRef } from 'react'
import { AdminApi } from '../../services/adminApi'
import TipTapRichTextEditor, {
  TipTapRichTextEditorHandle,
} from '../editor/TipTapRichTextEditor'
import './AdminRichTextEditor.css'
import '../editor/TipTapRichTextEditor.css'

export type AdminRichTextEditorProps = {
  value: string
  onChange: (html: string) => void
  className?: string
  placeholder?: string
  onUploadingChange?: (uploading: boolean) => void
  allowVideo?: boolean
}

export type AdminRichTextEditorHandle = {
  getEditor: () => any
  /** HTML đang hiện trong editor (ưu tiên khi Lưu) */
  getHtml: () => string
}

const AdminRichTextEditor = forwardRef<AdminRichTextEditorHandle, AdminRichTextEditorProps>(
  function AdminRichTextEditor(
    { value, onChange, className = '', placeholder, onUploadingChange, allowVideo: _allowVideo = false },
    ref
  ) {
    const innerRef = useRef<TipTapRichTextEditorHandle | null>(null)

    useImperativeHandle(ref, () => ({
      getEditor: () => innerRef.current?.getEditor?.() ?? null,
      getHtml: () => innerRef.current?.getHtml?.() || '',
    }))

    const uploadImage = async (file: File) => {
      const res = await AdminApi.uploadImage(file)
      if (!res.success || !res.data?.url) {
        throw new Error(res.message || 'Upload ảnh thất bại')
      }
      return res.data.url
    }

    return (
      <TipTapRichTextEditor
        ref={innerRef}
        value={value}
        onChange={onChange}
        className={className}
        placeholder={placeholder}
        onUploadingChange={onUploadingChange}
        uploadImage={uploadImage}
      />
    )
  }
)

export default AdminRichTextEditor
